var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_566_3",
    "data-name": "Component 566 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10697",
    "data-name": "Rectangle 10697",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_2_",
    "data-name": "home (2)",
    d: "M19.888,8.666l0,0L11.759.537a1.834,1.834,0,0,0-2.594,0L1.041,8.66l-.008.008a1.834,1.834,0,0,0,1.221,3.125l.057,0h.324v5.981a2.149,2.149,0,0,0,2.147,2.147h3.18a.584.584,0,0,0,.584-.584V14.652a.981.981,0,0,1,.98-.979H11.4a.981.981,0,0,1,.979.979v4.689a.584.584,0,0,0,.584.584h3.18a2.149,2.149,0,0,0,2.147-2.147V11.8h.3a1.835,1.835,0,0,0,1.3-3.131Zm-.827,1.768a.663.663,0,0,1-.472.2h-.884a.584.584,0,0,0-.584.584v6.565a.98.98,0,0,1-.979.979h-2.6V14.652A2.149,2.149,0,0,0,11.4,12.5H9.524a2.15,2.15,0,0,0-2.147,2.147v4.106h-2.6a.981.981,0,0,1-.979-.979V11.213a.584.584,0,0,0-.584-.584h-.9A.666.666,0,0,1,1.862,9.49h0L9.99,1.362a.666.666,0,0,1,.943,0l8.126,8.126,0,0a.668.668,0,0,1,0,.942Zm0,0",
    transform: "translate(1.5 2.001)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenu);
export default __webpack_public_path__ + "static/media/home-menu.215dc599813c37076f22169dcc73bdf3.svg";
export { ForwardRef as ReactComponent };